import { getSlugFromPath } from '@hopin-team/dashboard-shared';
import { useTranslation } from '@hopin-team/provider-translation';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

/**
 * Upgrade banner shown in Content Composer tab when user doesn't have
 * content repurposing license (hasContentHubCreatorLabAccess = false).
 * This is a simplified version of the Lab's upgrade banner that fits
 * within the context menu panel.
 */
export const UpgradeBanner = () => {
  const { t } = useTranslation();
  const slug = useMemo(() => getSlugFromPath(window.location.pathname), []);
  const choosePlanButtonHref = `/org/${slug}/manage/billing`;

  return (
    <div className="h-full overflow-y-auto px-4 flex flex-col items-center justify-center gap-5">
      <div className="flex flex-col items-center gap-4 max-w-[20rem] text-center">
        <p className="text-xl font-medium text-white m-0">
          {t('content-recording.unlock-content-composer')}
        </p>
        <p className="text-sm leading-relaxed text-spring-neutral-b3 m-0">
          {t('content-recording.unlock-content-composer-description')}
        </p>
        <Link
          to={choosePlanButtonHref}
          className="h-9 rounded-[0.625rem] px-4 bg-spring-primary text-spring-neutral-b0 font-medium text-sm flex items-center justify-center hover:bg-spring-primary/90 hover:text-spring-neutral-b0 transition-colors no-underline"
        >
          {t('content-recording.choose-plan-now')}
        </Link>
      </div>
    </div>
  );
};
